module.exports = __webpack_public_path__ + "img/close.8bcde710.png";